// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import * as echarts  from 'echarts'
import $ from 'jquery'
import store from './vuex/store.js'
import './assets/style/table.scss'
import ECharts from 'vue-echarts/components/ECharts.vue'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Print from 'vue-print-nb'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import global from './components/global.vue'
Vue.use(Viewer)
Viewer.setDefaults({
    Options: { 'inline': false, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
Vue.use(Print);
Vue.use(ElementUI);
Vue.use(Vuex)
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);
Vue.component('chart', ECharts)
Vue.config.productionTip = false;
Vue.directive('preventReClick', {
    inserted (el, binding) {
      el.addEventListener('click', () => {
        if (!el.disabled) {
          el.disabled = true
          setTimeout(() => {
            el.disabled = false
          }, binding.value || 2000)
        }
      })
    }
})
// Vue.prototype.$axios = axios;
Vue.prototype.$echarts = echarts;
Vue.prototype.$Global = global
axios.defaults.withCredentials = false;
global.bus = new Vue();
Vue.prototype.setCookie = function(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var domain = null;
    if (/\.com$/i.test(location.host)) {
        domain = location.host.replace(/^[^\.]*\./i, '.');
    }
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + (cvalue) + "; " + expires + (domain ? ";domain=" + domain : '') + ";path=/";
}
Vue.prototype.getCookie = function(name) {
    // return 1;
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
        return unescape(arr[2]);
    } else
        return null;
}

function getCookieValueByKey(key) {
    return document.cookie.replace(new RegExp('(?:(?:^|.*;\\s*)' + key + '\\s*\\=\\s*([^;]*).*$)|^.*$'), "$1")
}

// 导入时间格式化组件库moment
import moment from 'moment'
// 定义一个全局的过滤器
Vue.filter('dateFormat', function(data, fmt) {
    return moment(data).format(fmt)
})
Vue.prototype.$moment = moment;
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js